export const NOW_PLAYING_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.NowPlayingTemplateInterface.NowPlayingTemplate';
